import { Injectable } from '@angular/core';
import { AbstractDialogService, DialogOptions } from '@examdojo/core/dialog';
import { GenericQuestionHistoryDialogComponent } from './generic-question-history-dialog.component';
import { QuestionHistoryConfig } from './generic-question-history.model';

export interface QuestionHistoryDialogInput {
  config: QuestionHistoryConfig;
}

@Injectable({
  providedIn: 'root',
})
export class GenericQuestionHistoryDialogService extends AbstractDialogService<
  QuestionHistoryDialogInput,
  void,
  typeof GenericQuestionHistoryDialogComponent
> {
  readonly id = 'generic-question-history-dialog';
  protected readonly component = GenericQuestionHistoryDialogComponent;

  protected override readonly dismissOnBreakpointChange = true;

  override openDialog({ input, options }: { input: QuestionHistoryDialogInput; options?: DialogOptions }) {
    return super.openDialog({
      input,
      options: {
        ...this.options,
        cssClass: 'modified-modal fullscreen',
        componentProps: {
          config: input.config,
        },
        ...options,
      },
    });
  }
}
